import { MMSwitchInput as LibraryInput } from 'mmfintech-portal-commons'
import type { MMSwitchInputProps } from 'mmfintech-portal-commons/types'

type SwitchVariant = 'default' | 'secondary'

type Props = Omit<MMSwitchInputProps<SwitchVariant>, 'size'>

const MMSwitchInput = (props: Props) => {
  return <LibraryInput {...props} />
}

export default MMSwitchInput
